<div *ngIf="currentLang === 'ja'">
  <div class="manual-link">
    <a [href]="manualTopLink">使い方トップ</a> » <a [href]="facilityDialogLink">施設情報（追加・編集）</a> » プライバシーポリシーダイアログの説明
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

  <mat-card appearance="outlined" class="manual-card">
    <mat-card-header>
      <mat-card-title><span>プライバシーポリシーダイアログの説明</span></mat-card-title>
    </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/policy-dialog.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> 閉じるボタン
        </div>
        <div class="manual-explain">
          クリックすることでダイアログを閉じます。<br>
          その際、選択した内容は反映されません。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> 全言語自動翻訳
        </div>
        <div class="manual-explain">
          全言語の自動翻訳チェックボックスに対して、ON/OFFを切り替えます。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> プライバシーポリシー（メイン言語）
        </div>
        <div class="manual-explain">
          プライバシーポリシーを設定します。<br>
          <a [href]="projectDialogLink">プロジェクト情報：編集画面</a>で設定された言語の１番目のものがメイン言語となります。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> プライバシーポリシー（翻訳用）
        </div>
        <div class="manual-explain">
          自動翻訳用のプライバシーポリシーを設定します。<br>
          ここで設定された内容をもとに各言語の翻訳を行います。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/E.png"> プライバシーポリシー（他言語）
        </div>
        <div class="manual-explain">
          プライバシーポリシーを設定します。<br>
          自動翻訳チェックボックスをONにすることで翻訳処理が実行されます。（設定内容は翻訳処理によって上書きされます）
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/F.png"> 更新ボタン
        </div>
        <div class="manual-explain">
          クリックすることで編集した内容を反映します。
        </div>

      </mat-card-content>
    </mat-card>

  </div>
</div>
<div *ngIf="currentLang === 'en'">
  <div class="manual-link">
    <a [href]="manualTopLink">Usage Top</a> » <a [href]="facilityDialogLink">Facility Information (Add/Edit)</a> » Privacy Policy Dialog Description
  </div>
  
  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">
  
    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>Privacy Policy Dialog Description</span></mat-card-title>
      </mat-card-header>
  
      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/en_policy-dialog.png" width="100%">
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> Close Button
        </div>
        <div class="manual-explain">
          Click to close the dialog.<br>
          Any changes made will not be applied.
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> Automatic Translation for All Languages
        </div>
        <div class="manual-explain">
          Toggles the automatic translation checkbox for all languages ON/OFF.
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> Privacy Policy (Main Language)
        </div>
        <div class="manual-explain">
          Configure the privacy policy.<br>
          The first language set in the <a [href]="projectDialogLink">Project Information: Edit Screen</a> becomes the main language.
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> Privacy Policy (For Translation)
        </div>
        <div class="manual-explain">
          Configure the privacy policy for automatic translation.<br>
          The content set here will be used for translations into other languages.
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/E.png"> Privacy Policy (Other Languages)
        </div>
        <div class="manual-explain">
          Configure the privacy policy.<br>
          Enabling the automatic translation checkbox will execute the translation process. (The content will be overwritten by the translation process.)
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/F.png"> Update Button
        </div>
        <div class="manual-explain">
          Click to apply the changes made.
        </div>
  
      </mat-card-content>
    </mat-card>
  
  </div>  
</div>